import axios from "axios";
import { shopProductDimensionsListUrl, shopProductsDimensionCRUDUrl } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

const authConfig = () => ({
    headers: {
        Authorization: `Token ${getUserToken()}`,
    },
});

/** Do not set Content-Type — axios sets multipart boundary when body is FormData */
const multipartConfig = () => ({
    headers: {
        Authorization: `Token ${getUserToken()}`,
    },
});

/** @param {string} [query] e.g. `?search=Motor&page=2&page_size=10` — GET /dashboard/shop-product-dimensions/ */
export const getShopProductDimensions = async (query = "") => {
    const suffix = query.startsWith("?") ? query : query ? `?${query}` : "";
    return axios.get(`${shopProductDimensionsListUrl}${suffix}`, authConfig());
};

export const postShopProductDimension = async (formData) => {
    return axios.post(shopProductsDimensionCRUDUrl, formData, multipartConfig());
};

export const patchShopProductDimension = async (id, formData) => {
    return axios.patch(`${shopProductsDimensionCRUDUrl}${id}/`, formData, multipartConfig());
};

export const deleteShopProductDimension = async (id) => {
    return axios.delete(`${shopProductsDimensionCRUDUrl}${id}/`, authConfig());
};
